import styled, {css} from "styled-components";
import imgButton from "@PUBLIC/P/images/btn/btn_spr.png";

const IconButton = styled.button<{icon: string; isActive?: boolean}>`
	display: inline-flex;
	align-items: center;
	gap: 10px;
	background-color: transparent;

	${props => {
		if (props.icon === "enquire") {
			return css`
				&:before {
					content: "";
					display: inline-block;
					width: 20px;
					height: 19px;
					background: transparent url(${imgButton}) -44px -18px / 93px 40px;
					z-index: 1;
				}
			`;
		}

		if (props.icon === "print") {
			return css`
				&:before {
					content: "";
					display: inline-block;
					width: 20px;
					height: 20px;
					background: transparent url(${imgButton}) -66px -18px / 93px 40px;
					z-index: 1;
				}
			`;
		}

		if (props.icon === "share") {
			return css`
				&:before {
					content: "";
					display: inline-block;
					width: 17px;
					height: 17px;
					background: transparent url(${imgButton}) -76px 0 / 93px 40px;
					z-index: 1;
				}
			`;
		}

		if (props.icon === "wishList") {
			return css`
				&:before {
					content: "";
					display: inline-block;
					width: 20px;
					height: 16px;
					background-image: url(${imgButton});
					background-size: 93px 40px;
					background-color: transparent;
					background-position: ${props.isActive ? "-55px 0px" : "-35px 0px"};
					z-index: 1;
				}
			`;
		}
	}}
`;

export default IconButton;
